export const ja = {
  header: { title: "どの言語でもビデオで簡単で高速な音声置換！", subtitle: "🔥結果にのみ支払い – 1秒あたりわずか$0.099。🔥" },
  steps: { uploadVideo: "ビデオをアップロード", selectLanguages: "言語を選択", conversionResult: "変換と結果" },
  upload: { dragAndDrop: "ビデオファイルをここにドラッグ＆ドロップ", orClickToSelect: "またはクリックして選択", supportedFormats: "サポート形式：MP4、AVI、MOV、MKV、WebM", maxFileSize: "• 最大ファイルサイズ：250 MB", maxDuration: "• 最大時間：15分", processingTime: "• 処理時間はビデオ解像度に応じて2〜15分", chooseFile: "ファイルを選択", selectedFile: "選択されたファイル：", size: "サイズ：", fileTypeError: "ビデオファイルを選択してください", fileSizeError: "ファイルサイズ（{size} MB）が250 MBの最大制限を超えています", durationError: "ビデオ時間（{duration}分）が15分の最大制限を超えています", fileReadError: "ビデオファイルを読み取れません。別のファイルを試してください。" },
  languages: { sourceAudioLanguage: "ソース音声言語", targetAudioLanguage: "ターゲット音声言語", selectLanguage: "言語を選択..." },
  languageOptions: { ru: "ロシア語", en: "英語", es: "スペイン語", fr: "フランス語", de: "ドイツ語", it: "イタリア語", pt: "ポルトガル語", pl: "ポーランド語", zh: "中国語", ja: "日本語", ko: "韓国語", bg: "ブルガリア語", hr: "クロアチア語", cs: "チェコ語", da: "デンマーク語", nl: "オランダ語", et: "エストニア語", fi: "フィンランド語", el: "ギリシャ語", hu: "ハンガリー語", ga: "アイルランド語", lv: "ラトビア語", lt: "リトアニア語", mt: "マルタ語", ro: "ルーマニア語", sk: "スロバキア語", sl: "スロベニア語", sv: "スウェーデン語" },
  conversion: { replaceAudio: "音声を置換", uploadVideoAndSelectLanguages: "ビデオをアップロードして言語を選択して続行", fixValidationError: "上記のファイル検証エラーを修正してください", createSubtitles: "字幕を作成", uploadVideoForSubtitles: "字幕を作成するためにビデオをアップロード", selectTranslationLanguage: "翻訳言語を選択" },
  demo: { seeVeviInAction: "VEVIの実動を見る", watchHowItWorks: "我々のAI音声置換技術がどのように動作するかを見る", beforeEnglish: "前（英語）", originalPresentation: "オリジナル企業プレゼンテーション", afterSpanish: "後（スペイン語,フランス語,中国語,イタリア語）", aiTranslatedVoice: "自然な音声でAI翻訳", demoTitle: "デモ - VEVI実動" },
  reviews: { title: "お客様の声", subtitle: "世界中のマーケティング専門家に信頼されています", customerReviews: [{ name: "サラ・ジョンソン", position: "デジタルマーケティングマネージャー", company: "TechFlow Solutions", text: "VEVIは我々の国際マーケティングキャンペーンを変革しました！" }, { name: "マイケル・チェン", position: "コンテンツマーケティングディレクター", company: "GlobalReach Media", text: "複数地域のビデオコンテンツを管理する者として、VEVIはゲームチェンジャーです。" }, { name: "エマ・ロドリゲス", position: "ブランドマーケティングスペシャリスト", company: "InnovateCorp", text: "新市場に拡大しながらボイスオーバーコストで数千ドル節約しました。" }, { name: "デイビッド・トンプソン", position: "マーケティングキャンペーンマネージャー", company: "NextGen Brands", text: "VEVIのスピードと品質は比類がありません。" }, { name: "リサ・パーク", position: "ソーシャルメディアマーケティングリード", company: "CreativeEdge Agency", text: "VEVIにより我々の小さなエージェンシーがクライアントに多言語ビデオサービスを提供できるようになりました。" }, { name: "ジェームス・ウィルソン", position: "パフォーマンスマーケティングディレクター", company: "ScaleUp Ventures", text: "パフォーマンスマーケティングではROIがすべてで、VEVIはそれを提供します。" }] },
  payment: { title: "変換支払い", processingCost: "処理コスト", duration: "時間：", baseCost: "基本コスト", discount: "割引（{promoCode}）：", discountAmount: "割引額：", total: "合計：", emailToReceiveResult: "結果を受信するメール", emailPlaceholder: "your-email@example.com", promoCode: "🎟️ プロモコード（オプション）", promoCodePlaceholder: "プロモコードを入力", check: "確認", checking: "確認中...", addSubtitles: "ビデオに字幕を追加", addSubtitlesDescription: "ターゲット言語で字幕を生成して埋め込む", highQualityTranslation: "• 高品質AI翻訳", originalVideoPreserved: "• オリジナルビデオ保持", fastProcessing: "• 高速処理（通常5-10分）", resultWillBeSent: "• 結果は指定されたメールに送信されます", cancel: "キャンセル", continue: "続行", enterEmail: "メールアドレスを入力してください", enterValidEmail: "有効なメールアドレスを入力してください", enterPromoCode: "プロモコードを入力してください", invalidPromoCode: "無効なプロモコード", validPromoCode: "有効なプロモコード！{discount}%割引が適用されました" },
  progress: { title: "ビデオ処理中", uploadingAndExtracting: "🎬 アップロードと音声抽出", transcribingAndTranslating: "🗣️ 音声転写と翻訳", synthesizingAudio: "🎵 新しい音声トラック合成", step: "ステップ：", error: "エラー" },
  result: { title: "完了！あなたのビデオが処理されました", conversionCompleted: "変換が正常に完了しました！", processedVideoDescription: "🎬 音声クローニング付きの処理済みビデオ", payAndDownload: "支払いとダウンロード", videoNotAvailable: "ビデオが利用できません", useDownloadButton: "下のダウンロードボタンを使用してください", downloadError: "ダウンロードエラー" },
  emailSent: { title: "ビデオ送信完了！🎉", videoOnWay: "ビデオはすでにあなたのメールに向かっています🙏❤️", checkInbox: "受信トレイとスパムフォルダを確認してください。処理されたビデオはすぐに届きます！", whatsNext: "次は何ですか？", checkEmail: "• あなたのメール（{email}）を確認", checkSpam: "• 見つからない場合はスパム/迷惑メールフォルダを確認", downloadAndEnjoy: "• ダウンロードしてダビングされたビデオをお楽しみください！", close: "閉じる", processAnotherVideo: "別のビデオを処理" },
  processingSteps: { uploading: "ビデオアップロード中...", extracting: "音声抽出中...", transcribing: "音声転写中...", translating: "コンテンツ翻訳中...", synthesizing: "新しい音声合成中...", rendering: "最終ビデオレンダリング中...", complete: "処理完了！" },
  common: { minutes: "分", seconds: "秒", loading: "読み込み中...", error: "エラー", success: "成功" },
  socialMedia: {
    title: "つながり続ける",
    description: "AI音声技術の最新情報を入手"
  },

  // Services (for Footer)
  services: {
    dubbing: "吹き替え",
    voiceClone: "音声クローン吹き替え",
    newVoice: "新しい音声吹き替え",
    multilingual: "多言語吹き替え",
    multiSpeaker: "マルチスピーカー吹き替え",
    subtitles: "字幕",
    subtitlesOnly: "字幕のみ",
    multilingualSubtitles: "多言語字幕",
    subtitlesDescription: "あらゆるプラットフォーム向けに正確な字幕を自動生成します。",
    subtitlesPrice: "処理コスト: $0.01/秒",
    addSubtitles: "字幕を追加",
    needsTranslation: "翻訳が必要ですか？",
    translationLanguage: "翻訳言語"
  },

  // Footer
  footer: {
    legal: "法的情報",
    privacyPolicy: "プライバシーポリシー",
    termsOfUse: "利用規約"
  },

  // Navigation
  nav: {
    blog: "ブログ"
  },

  // Blog (using English content as fallback)
  blog: {
    title: "VEVI Monster ブログ",
    subtitle: "VEVI宇宙の歴史と神話",
    readMore: "続きを読む",
    backToBlog: "ブログに戻る",
    articleNotFound: "記事が見つかりません",
    characteristics: "特徴",
    articles: {
      "vevi-monster": {
        title: "VEVI Monster",
        excerpt: "VeviはZera-13bのプラズマ渦から生まれた存在です。彼は肉でも金属でもありません—彼の体は電磁場によって保持された振動する粒子で構成されています。",
        metadata: {
          "銀河": "MoM-z14",
          "年齢": "134億年",
          "タイプ": "メタンとネオンの濃い大気を持つ岩石惑星",
          "星": "赤い原始星Zera-13",
          "軌道": "システムの2番目の惑星",
        },
        content: [
          "🌑 説明",
          "Zera-13bは、宇宙が輝くことを学び始めた時代に生まれた、古代のほとんど忘れられた世界です。",
          "その空は薄暗い緑の炎で輝き、濃い大気はネオンストームで震えます。表面は、メタン風が空気に火の痕跡を残すガラス質のクレーターで覆われた黒灰色の風景です。",
          "表面の下には凍ったガスの洞窟があり、伝説によれば、思考できる最初のエネルギーの形態が生まれました。",
          "👾 Vevi (Vevi Monster)",
          "VeviはZera-13bのプラズマ渦から生まれた存在です。",
          "彼は肉でも金属でもありません—彼の体は電磁場によって保持された振動する粒子で構成されています。",
          "彼の目は星Zera-13の反射光で輝き、彼の声はネオン風のささやきのように聞こえます。",
          "Veviは原始星が消え始めたときに彼の世界を去りました。彼は新しいエネルギーを探す本能に導かれて、銀河間の空虚を旅しました。",
          "今、彼は世界をさまよい、Zera-13bの原始の光の粒子を携えています。",
          "輝きは惑星から来ました",
          "彼には足がありません—惑星には巨大な重力があり、彼は単に浮遊しているからです",
          "彼は（むしろ音を出す）イルカ、クジラ、シャチの音響波に似た方法でコミュニケーションを取ります。",
          "彼の言語はUFOnicと呼ばれています",
        ],
      },
      "baddy-sub": {
        title: "Baddy Sub",
        excerpt: "Baddy Subは、高い物質密度を持つ宇宙の希少な領域であるSub Zoneで生まれた、初期宇宙の存在です。",
        metadata: {
          "オブジェクト名": "Sub Zone (SUB-Z)",
          "オブジェクトタイプ": "原始クラスター / 銀河形成領域",
          "時代": "ビッグバン後約2〜3億年",
          "赤方偏移": "z ≈ 14–15",
          "赤経 (RA)": "02h 17m 43s",
          "赤緯 (Dec)": "−04° 12′ 09″",
        },
        content: [
          "Baddy Subデータ",
          "下部に2つの下肢、上部に拡張された形の3つの目を持つ長く細い楕円形の体",
          "彼には口がありません。",
          "腕として解釈できる2つの上部の細い肢もあります。",
          "各肢に2本の指。",
          "体全体が木の枝に似ています",
          "肌は滑らかなマット構造を持っています",
          "色は緑がかった茶色（色素沈着）です",
          "カメレオンのように環境から色を変えることができます。",
          "Baddy Subが生まれた惑星の説明:",
          "Sub Zoneは、最初の銀河構造が形成され始めた高い物質密度を持つ初期宇宙の希少な領域です。観測は、原始ガス、放射線、重力波の激しい相互作用を示しています。この領域は、典型的な原始銀河領域には特徴的でない不安定な信号パターンと異常な共鳴活動を記録しています。",
          "科学的意義:",
          "Sub Zoneは、銀河の組み立ての初期段階、若い宇宙での信号伝播、および混沌とした放射場から構造化された宇宙システムへの移行を研究するための重要なオブジェクトと見なされています。",
          "ステータス:",
          "未解決の形成領域として分類されています。さらなる研究が必要です。",
        ],
      },
    },
  },

  // FAQ
  faq: {
    title: "よくある質問",
    subtitle: "VEVIについて知っておくべきすべて",
    questions: [
      {
        question: "音声のみを扱っていますか？",
        answer: "はい — 自然で本物のまま、別の言語で聞こえるようにあなたの音声を置き換えます。"
      },
      {
        question: "支払いは前ですか後ですか？",
        answer: "後です。まず結果を聞いてから支払います。"
      },
      {
        question: "返金は？",
        answer: "不要です — 結果に満足した場合にのみ支払います。"
      },
      {
        question: "15分より長いビデオは？",
        answer: "問題ありません。オンラインチャットでAIアシスタントに手順を尋ねてください。"
      },
      {
        question: "別の音声を選択できますか？",
        answer: "いいえ — 自分の音声のみをクローンします。"
      },
      {
        question: "最低支払額は？",
        answer: "$0.50から。"
      },
      {
        question: "ビデオはどうやって入手しますか？",
        answer: "ブラウザで即座にダウンロード + 支払い後にメールにコピー送信。"
      },
      {
        question: "大量注文の割引は？",
        answer: "はい — オンラインチャットでAIアシスタントに連絡してください。"
      },
      {
        question: "答えが見つかりませんでしたか？",
        answer: "オンラインチャットでAIアシスタントに尋ねてください — お手伝いいたします。"
      },
      {
        question: "サポートされていない形式は？",
        answer: "コンバーターを使用するか、オンラインチャットのAIアシスタントから迅速なヘルプを入手してください。"
      },
      {
        question: "私のビデオには正しく発音する必要がある特定の用語が含まれています。それを制御できますか？",
        answer: "はい — オンラインチャットでAIアシスタントにメッセージを送るだけで、特定の用語をマークまたは保持する方法（たとえば、英語のままにする）の手順をお送りします。"
      },
      {
        question: "メールを受信していません。どうすればよいですか？",
        answer: "処理時間はキューの量により異なる場合があります。心配しないでください — ファイルは安全です。準備ができたら、通知または直接ダウンロードリンクを受け取ります。"
      }
    ]
  }
};
